import PatientDependentService from '../services/patientDependent.service';
import PatientUserService from '../services/patientUser.service';

const patientDependent = {
  namespaced: true,

  state: {},

  mutations: {},

  actions: {
    get(_, patientId) {
      return PatientDependentService.get(patientId);
    },
    getFamily(_, patientId) {
      return PatientDependentService.getFamily(patientId);
    },
    getAll(_, patientId) {
      return PatientDependentService.getAll(patientId);
    },
    one(_, { patientId, dependentId }) {
      return PatientDependentService.one(patientId, dependentId);
    },
    create(_, dependent) {
      return PatientDependentService.create(dependent);
    },
    update(_, dependent) {
      return PatientDependentService.update(dependent);
    },
    unlink(_, { patientId, dependentId }) {
      return PatientDependentService.unlink(patientId, dependentId);
    },
    uploadAvatar(_, { patientId, base64Image }) {
      return PatientUserService.uploadAvatar(patientId, base64Image).then(res => res);
    },
  },

  getters: {},
};

export default patientDependent;
